<template>
  <BaseSimpleLayout class="device-edit-confirm">
    <template #title>端末情報編集確認</template>
    <template #main>
      <div class="device-edit-confirm-table-line">
        <BaseDataTable :table-data="confirmLeftData" :label-width="140" />
      </div>
      <div class="device-edit-confirm-table-line">
        <BaseDataTable :table-data="confirmRightData" :label-width="140" />
      </div>
      <div class="device-edit-confirm-button-area">
        <el-button
          size="large"
          type="info"
          @click="router.push('/device/edit')"
        >
          戻る
        </el-button>
        <el-button size="large" type="primary" @click="put()">登録</el-button>
      </div>
    </template>
  </BaseSimpleLayout>
</template>

<script setup lang="ts">
  import { ref } from 'vue';
  import { useStore } from 'vuex';
  import router from '@/router';
  import BaseSimpleLayout from '@/components/BaseSimpleLayout.vue';
  import BaseDataTable from '@/components/BaseDataTable.vue';
  import {
    deviceType,
    handlingType,
    deviceStatus,
    isMccsTypeT
  } from '@/libs/device';
  import { DetailTableData } from '@/types/common';

  const store = useStore();
  const confirmLeftData = ref<DetailTableData[]>([]);
  const confirmRightData = ref<DetailTableData[]>([]);
  const initialize = () => {
    const putData = store.state.device.putData;
    if (!putData) {
      return router.push('/device');
    }
    const companyNameData = store.state.companiesMaster.replaceData;
    const leftRows: DetailTableData[] = [
      {
        label: 'ID',
        value: putData.id
      },
      {
        label: 'ステータス',
        value: deviceStatus[putData.status]
      },
      ...(isMccsTypeT(putData.deviceType)
        ? []
        : [
            {
              label: 'SIM番号',
              value: putData.simNumber
            }
          ]),
      {
        label: 'IMSI',
        value: putData.simImsi
      },
      {
        label: 'シリアル番号',
        value: putData.serialCode
      },
      {
        label: '端末タイプ',
        value: deviceType[putData.deviceType]
      },
      {
        label: 'マイナーVer.',
        value: putData.deviceMinorVersion
      },
      {
        label: '製造番号',
        value: putData.deviceCode
      },
      {
        label: '取扱',
        value: handlingType[putData.handlingType]
      },
      {
        label: '確定端末',
        value: putData.orderCompanyId
          ? companyNameData[putData.orderCompanyId].name
          : '-'
      }
    ];
    confirmLeftData.value = leftRows;
    confirmRightData.value = [
      {
        label: '出荷ファームVer',
        value: putData.firmVersion
      },
      {
        label: '出荷コンフィグ',
        value: putData.configName
      },
      {
        label: 'IBバッテリー',
        value: putData.internalBatteryVoltage
      },
      {
        label: 'Mboot',
        value: putData.mboot
      },
      {
        label: '設定ID',
        value: putData.deviceSettingUser
      },
      {
        label: '設定パスワード',
        value: putData.deviceSettingPassword
      },
      {
        label: '備考',
        value: putData.note
      }
    ];
  };
  const put = () => {
    store.dispatch('device/put');
  };
  initialize();
</script>
<style lang="scss">
  .device-edit-confirm {
    .main-container {
      width: 900px;
    }
    .device-edit-confirm-table-line {
      width: 400px;
      margin: 0px 25px 20px;
      float: left;
    }
    .device-edit-confirm-button-area {
      clear: left;
      margin: 20px 0px;
      .el-button {
        font-weight: 600;
      }
    }
  }
</style>
